<template>
  <div class="content-warp" v-if="person">
    <a-row class="brief-bar" type="flex" justify="space-between" align="middle">
      <a-row type="flex" justify="start" align="middle">
        <a-col class="brief-title">{{person.name}}</a-col>
        <a-col class="brief-subtitle">{{person.idNumber}}</a-col>
        <a-col class="brief-subtitle">{{person.deptFullName}}</a-col>
      </a-row>
      <a-col style="color: #999;">{{$t('personalManaAuth.creationTime')}}{{person.createdAt}}</a-col>
    </a-row>

    <a-form 
      layout="inline" 
      :form="form" 
      @submit.prevent="handleSubmitValidTime"
    > 
      <a-row class="content-panle bg-white margin-0" :gutter="30">            
        <a-col :span="24" class="padding-tb-md">
          <h3 class="panle-head">{{$t('personalManaAuth.expiryDateTitle')}}</h3>
          <a-col :span="24" >
            <a-form-item :label="$t('personalManaAuth.expiryDateTxt')">
              <a-range-picker
                dropdownClassName="form-date-picker"
                :getCalendarContainer="trigger => trigger.parentNode"
                format="YYYY-MM-DD"
                :placeholder="[$t('personalManaAuth.dateStartTxt'), $t('personalManaAuth.dateEndTxt')]"
                :ranges="dateRangesBtn"
                :disabled="validTimeForever"
                v-decorator="[
                  'validTime',
                  { 
                    initialValue: person.expiryDateMoment || [moment(), moment()],
                    rules: [
                      { required: !validTimeForever, message: $t('personalMana.expiryDateBlank') },
                      { validator: handleValidAuthRange },
                    ] 
                  }
                ]"
              />
            </a-form-item>
            <a-form-item :label="$t('personalManaAuth.permanentTxt')">
              <a-switch 
                v-decorator="['validForever']"
                :checked="validTimeForever"
                @change="handleForeverAuthSwitchChange"
              />
            </a-form-item>

            <a-form-item style="margin-left: 20px">
              <a-button type="primary" html-type="submit" :loading="submittingValidTime">{{$t('personalManaAuth.saveBtn')}}</a-button>
            </a-form-item>
          </a-col>
        </a-col>
      </a-row> 
    </a-form>
    
    <div class="content-panle bg-white" style="margin-top:5px">      
      <a-row class="margin-0" :gutter="24">

        <a-col :span="12" class="padding-tb-md">
          <h3 class="panle-head" style="margin:8px 0">
            {{$t('personalManaAuth.authDeviceTitle')}} -- 
            <span class="panle-title">
              {{$t('personalManaAuth.authedDeiveCountTips')}}
              <span style="color: #1890FF">{{authedDeiveCountStr}}</span>
            </span>
          </h3>
          <a-table
            :columns="authedDevicesColumns" 
            :dataSource="authedDevices"
            :pagination="false"
            :loading="authedDevicesloading"
            :scroll="authedDevices.length?{ x: 700 }:{}"
          >
            <template slot="operation" slot-scope="text, record">
              <a 
                :disabled="record.operation.disabled"
                :style="{color: '#f5222d'}"
                @click="record.operation.callback(record)"
              >
                {{record.operation.type}}
              </a>
            </template>
          </a-table>
        </a-col>

        <a-col :span="12" class="padding-tb-md">
          <a-form layout="inline" :form="listSearchForm" @submit.prevent="handleSearchDevices" style="text-align: right;">
            <a-form-item>
              <a-tree-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                style="width: 130px"
                :placeholder="$t('personalManaAuth.searchOrgTxt')"
                :dropdownStyle="{ maxHeight: '400px', overflow: 'auto' }"
                :treeData="orgTreeDownSelectionData"
                :treeDefaultExpandedKeys="[orgTreeDownSelectionData[0].value]"
                v-decorator="['deptId', {initialValue: orgTreeDownSelectionData[0].value}]"
              />
            </a-form-item>
            <a-form-item>
              <a-select
                dropdownClassName="form-select"
                :getPopupContainer="trigger => trigger.parentNode"
                style="width: 110px"
                :placeholder="$t('personalManaAuth.searchDeviceStatus')"
                :options="searchStatusOptions"
                v-decorator="['searchStatus']"
              />
            </a-form-item>
            <a-form-item>
              <a-input 
                style="width: 110px"
                type="text"
                v-decorator="['searchSNOrName']" 
                :placeholder="$t('personalManaAuth.searchDeviceSNOrName')" >
                <a-icon slot="prefix" type="setting" style="color:rgba(0,0,0,.25)" />
              </a-input>
            </a-form-item>
            <a-form-item style="margin-right:0">
              <a-button type="primary" html-type="submit" :loading="loading">
                {{$t('personalManaAuth.searchBtn')}}
              </a-button>
            </a-form-item>
          </a-form>

          <a-table
            :columns="devicesColumns" 
            :dataSource="devicesData"
            :pagination="pagination"
            :loading="loading"
            @change="handleTableChange"
            :scroll="devicesData.length?{ x: 900 }:{}"
          >
            <span slot="status" slot-scope="text, record">
              <a-tag v-if="text === '不在线'" color="volcano">{{text}}</a-tag>
              <a-tag v-else color="green">{{text}}</a-tag>
            </span>

            <template slot="operation" slot-scope="text, record">
              <a
                :disabled="record.operation.disabled"
                :style="{color: '#1890ff'}"
                @click="record.operation.callback(record)"
              >
                {{record.operation.type}}
              </a>
            </template>
          </a-table>
        </a-col>        
      </a-row>
    </div>      
    
  </div>
</template>

<script>
import moment from 'moment';
import 'moment/locale/zh-cn';
import { mapGetters, mapState } from 'vuex';
import { getPersonalAuthedDevices, getPersonalUnauthedDevices, modifyPersonalAuthorization, updateAuthorizedPeriod } from '@/api/authMana';

export default {
  name: 'personalManaAuth',
  components: {},
  data() {
    return {
      person: null,
      
      listSearchForm: this.$form.createForm(this),
      searchStatusOptions: [],

      searchDeptId: '',
      searchStatus: undefined,
      searchSNOrName: undefined,

      loading: false, // 列表内容是否在加载中
      devicesData: [], // 列表数据源
      devicesColumns: this.getDevicesColumns(), // 列表表头项
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },

      authedDevicesloading: false,
      authedDevicesColumns: this.getAuthedDevicesColumns(),
      authedDevices: [],
      authedDeviceIds: [],
      authedDeiveCountStr: new Function('count', this.$t('personalManaAuth.authedDeiveCount'))('0'),

      form: this.$form.createForm(this),
      validTimeForever: false,
      submittingValidTime: false,

      // 有效期 date-range-picker
      dateRangesBtn: this.getDateRangesBtn()
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData,
      orgTreeSourceData: state => state.orgStore.orgTreeSourceData
    }),
    ...mapGetters(['orgTreeDownSelectionData'])
  },
  watch: {
    lang: function (lang) {
      this.authedDevicesColumns = this.getAuthedDevicesColumns()
      this.devicesColumns = this.getDevicesColumns()
      this.dateRangesBtn = this.getDateRangesBtn()
      this.authedDeiveCountStr = new Function('count', this.$t('personalManaAuth.authedDeiveCount'))(this.authedDevices.length.toString())

      this.getPersonAuthedDevices()
      this.getDevicesListData()
    }
  },
  beforeCreate() {
    if (!this.$route.params.person) {
      this.$error({
        title: this.$t('personalManaEdit.pageErrTitle'),
        content: this.$t('personalManaEdit.pageErrContent'),
        okText: this.$t('personalManaEdit.backBtn'),
        onOk: () => {
          this.$multiTab.closeCurrentPage();
          this.$router.push({ name: 'personalManaIndex' });
        }
      });
    };
  },
  created() {
    // console.log('----personalManaAuth created------', this.$route.params)

    this.onlineStateMap = {};
    this.enumsData.onlineState.forEach(item => {
      this.onlineStateMap[item.value] = item.title;
    })

    this.searchStatusOptions = [].concat([{ title: this.$t('personalManaAuth.searchDeviceStatusAllOption'), value: '', key: 'all' }], this.enumsData.onlineState);
  },
  activated() {
    if (this.$route.params.person) {
      if (this.person && this.person.id === this.$route.params.person.id) return;

      this.person = this.$route.params.person;
      if (this.person.expiryDateMoment) {
        this.validTimeForever = this.person.expiryDateMoment[1].diff(this.person.expiryDateMoment[0], 'years') >= 100;
      }

      this.getPersonAuthedDevices()
      this.getDevicesListData()
    }
  },
  
  methods: {
    moment,

    getAuthedDevicesColumns() {
      return [
        {
          title: this.$t('personalManaAuth.listAuthedDeviceSN'),
          dataIndex: 'SN',
          width: '25%'
        },
        {
          title: this.$t('personalManaAuth.listAuthedDeviceName'),
          dataIndex: 'name',
          width: '25%'
        },
        {
          title: this.$t('personalManaAuth.listAuthedDeviceOrg'),
          dataIndex: 'deptFullName',
          width: '35%'
        },
        {
          title: this.$t('personalManaAuth.listAuthedDeviceOperation'),
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },
    getDevicesColumns() {
      return [
        {
          title: this.$t('personalManaAuth.listDeviceSN'),
          dataIndex: 'SN',
          width: '20%'
        },
        {
          title: this.$t('personalManaAuth.listDeviceName'),
          dataIndex: 'name',
          width: '20%'
        },
        {
          title: this.$t('personalManaAuth.listDeviceStatus'),
          dataIndex: 'status',
          width: '15%',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: this.$t('personalManaAuth.listDeviceOrg'),
          dataIndex: 'deptFullName',
          width: '32%'
        },
        {
          title: this.$t('personalManaAuth.listDeviceOperation'),
          dataIndex: 'operation',
          fixed: 'right',
          scopedSlots: { customRender: 'operation' }
        }
      ]
    },

    // 获取时间段选择插件快捷按钮内容
    getDateRangesBtn() {
      const btns = {}
      btns[this.$t('personalManaAuth.comingWeekBtn')] = [this.moment(), this.moment().add(6, 'days')]
      btns[this.$t('personalManaAuth.comingMonthBtn')] = [this.moment(), this.moment().add(1, 'months')]
      btns[this.$t('personalManaAuth.comingHalfYearBtn')] = [this.moment(), this.moment().add(6, 'months')]
      btns[this.$t('personalManaAuth.comingYearBtn')] = [this.moment(), this.moment().add(1, 'years')]
      
      return btns
    },
    // 授权时间段校验
    handleValidAuthRange(rule, value, callback) {
      // console.log('--handleValidAuthRange--', value) 
      if (value.length && value[1].diff(value[0], 'years', true) > 1 && !this.validTimeForever) {
        callback(this.$t('personalMana.expiryDateWarning'));
        return;
      }
      callback();
    },
    // 永久授权开关变动
    handleForeverAuthSwitchChange(data) {
      // console.log('----', data)
      this.form.resetFields();
      this.validTimeForever = data;
      if (data) {
        this.form.setFieldsValue({ validTime: [moment(), moment().add(100, 'years')] });
      } else {
        this.form.setFieldsValue({ validTime: [moment(), moment()] });
      }      
    },
    // 提交有效期设置
    handleSubmitValidTime() {
      this.form.validateFields(async (err, values) => {
        // console.log('--handleSubmitValidTime--', err, values)
        if (!err) {
          try {
            this.submittingValidTime = true
            await updateAuthorizedPeriod({
              personId: this.person.id,
              authStart: values.validTime[0].format('YYYY-MM-DD') || null,
              authEnd: values.validTime[1].format('YYYY-MM-DD') || null
            })
            this.submittingValidTime = false
            this.$notification.success({
              message: this.$t('personalManaAuth.editExpiryDateSuccess'),
              duration: 2
            })
          } catch (error) {
            this.submittingValidTime = false
          }
        }
      });
    },

    // 获取当前人员所有的已授权设备
    async getPersonAuthedDevices() {
      try {
        this.authedDevicesloading = true
        const res = await getPersonalAuthedDevices({ id: this.person.id })
        this.authedDevicesloading = false

        this.authedDeviceIds = []
        this.authedDevices = res.data.collection.map(item => {
          this.authedDeviceIds.push(item.deviceId)
          return {
            key: item.deviceId,
            id: item.deviceId,
            SN: item.deviceSn,
            name: item.deviceName,
            deptFullName: item.deptFullName,
            deptid: item.deptId,
            operation: {
              type: this.$t('personalManaAuth.listRemoveAuthedDeviceBtn'),
              disabled: false,
              callback: this.handleDeleteSelected
            }
          }
        });
        this.authedDeiveCountStr = new Function('count', this.$t('personalManaAuth.authedDeiveCount'))(this.authedDevices.length.toString())
      } catch (error) {
        this.authedDevicesloading = false
      }
    },

    // 搜索未授权设备列表
    handleSearchDevices() {
      this.listSearchForm.validateFields((err, values) => {
        if (!err) {
          this.searchDeptId = values.deptId;
          this.searchStatus = values.searchStatus;
          this.searchSNOrName = values.searchSNOrName;

          this.pagination.current = 1;
          this.getDevicesListData();
        }
      });
    },
    // 获取未授权设备列表数据
    async getDevicesListData() {
      try {
        this.loading = true
        const res = await getPersonalUnauthedDevices({
          id: this.person.id,
          deptId: this.searchDeptId || this.orgTreeDownSelectionData[0].value,
          deviceTypes: [101],
          perPage: this.pagination.pageSize,
          page: this.pagination.current,
          keyword: this.searchSNOrName && this.searchSNOrName.trim(),
          onlineState: this.searchStatus
        })
        this.loading = false

        this.devicesData = this.createDevicesTableData(res.data.collection)
        this.pagination.total = res.data.size;
      } catch (error) {
        this.loading = false
      }
    },
    createDevicesTableData(data) {
      return data.map(item => {
        return {
          key: item.deviceId,
          id: item.deviceId,
          SN: item.deviceSn,
          name: item.deviceName,
          status: this.onlineStateMap[item.deviceOnlineState],
          doorState: item.doorState,
          version: item.softVer,
          personCount: item.authCount,
          deptFullName: item.deptFullName,
          deptid: item.deptId,
          operation: {
            type: this.$t('personalManaAuth.listAddDeviceBtn'),
            disabled: false,
            callback: this.handleAddSelected
          }
        }
      })
    },
    // 点击分页时触发
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.getDevicesListData()
    },

    // 添加授权设备
    async handleAddSelected(data) {
      try {
        this.$message.loading(this.$t('personalManaAuth.adding'), 0);
        this.authedDeviceIds.push(data.id);
        await this.handleSetAuthSubmit()

        setTimeout(() => {
          // 刷新已授权设备列表
          this.getPersonAuthedDevices()
          
          // 刷新未授权设备列表
          if (this.devicesData.length === 1 && this.pagination.current !== 1) {
            --this.pagination.current
          }
          this.getDevicesListData()
        }, 0)        
      } catch (error) {}
      
    },
    // 删除已授权设备
    async handleDeleteSelected(data) {
      // console.log('--handleDeleteSelected--', data)
      try {
        this.$message.loading(this.$t('personalManaAuth.removing'), 0);
        this.authedDeviceIds.splice(this.authedDeviceIds.indexOf(data.id), 1);
        await this.handleSetAuthSubmit()

        setTimeout(() => {
          // 刷新已授权设备列表
          this.getPersonAuthedDevices()
          // 刷新未授权设备列表
          this.getDevicesListData()
        }, 0)        
      } catch (error) {}

    },

    // 提交授权
    async handleSetAuthSubmit() {
      try {
        await modifyPersonalAuthorization({
          id: this.person.id,
          deviceIds: this.authedDeviceIds
        })
        this.$message.destroy()
        this.$notification.success({
          message: this.$t('personalManaAuth.editAuthorizedSuccess'),
          duration: 2
        })
      } catch (error) {
        this.$message.destroy()
      }
    },    

    // 返回人员列表
    handleBackPersonList() {
      this.$multiTab.closeCurrentPage();
      this.$router.push({ name: 'personalManaIndex' });
    }
  }

}
</script>

<style scoped>
.brief-bar {
  background-color: #fff;
  margin: 5px 0;
  padding: 10px 16px;
  border-radius: 5px;
}
.brief-bar .brief-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  margin-right: 10px;
}
.brief-bar .brief-subtitle {
  margin-right: 10px;
  color: #999;
}

.panle-table-title{
  margin: 0;
  padding: 8px 0;
  font-size: 16px;
}
</style>